import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { AgentousLogo } from '@/assets/images';
import bgImage from '@/assets/images/onboarding-bg-image.png';
import { Button } from '@/components/ui';
import { ROUTES } from '@/constants/routes';
import { useAuthEventContext } from '@/context/auth-event-context';

type Props = {
  children: ReactNode;
  level: number;
};

export default function ResetPasswordContainer({ children, level }: Props) {
  const { resetPasswordLevel, setResetPasswordLevelHandler } =
    useAuthEventContext();
  return resetPasswordLevel === level ? (
    <div
      style={{ backgroundImage: `url(${bgImage})` }}
      className="relative mx-auto flex min-h-screen max-w-full justify-center overflow-x-hidden bg-cover"
    >
      <Link className="absolute left-[7%] top-[5%]" to={ROUTES.HOME}>
        <div className="min-w-[80px] max-w-[117px]">
          <img loading="lazy" src={AgentousLogo} className={`h-full w-full`} />
        </div>
      </Link>
      {children}
      {level !== 1 && (
        <div className="absolute bottom-[10%] right-[7%]">
          <Button
            onClick={() => setResetPasswordLevelHandler(level - 1)}
            className="h-[20px] w-full max-w-[100px] bg-primary text-white disabled:bg-transparent disabled:text-primary"
          >
            <p className="text-[10px]">Back</p>
          </Button>
        </div>
      )}
    </div>
  ) : null;
}
